<template>
  <div class="page-content">
    <div class="content-wrapper">
      <div class="content">
        <div class="mb-4 d-flex justify-content-between align-items-center">
          <h4 class="font-weight-semibold mb-0">Data Summary</h4>
          <div class="d-flex align-items-center">
            <date-picker
              v-model="dateRange"
              range
              value-type="YYYY-MM-DD"
              format="D MMM YYYY"
              style="max-width: 260px;"
              class="mr-2"
            ></date-picker>
            <button class="btn btn-primary" @click="loadData" :disabled="isLoading || !dateRange[0] || !dateRange[1]">
              <i v-if="isLoading" class="icon-spinner2 spinner mr-1"></i>
              Search
            </button>
          </div>
        </div>

        <div v-if="summaryHeader" class="summary-card">
          <div class="summary-header d-flex justify-content-between align-items-center">
            <span>{{ summaryHeader }}</span>
            <button class="btn btn-sm btn-copy" @click="copySummary" :title="copied ? 'Copied!' : 'Copy summary'">
              <i :class="copied ? 'fas fa-check' : 'fas fa-copy'"></i>
              {{ copied ? 'Copied!' : 'Copy' }}
            </button>
          </div>
          <div class="summary-body" v-html="summaryBody"></div>
        </div>

        <div v-else-if="!isLoading && searched" class="text-muted">
          No data found.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import serviceRoutes from '../service-routes'

export default {
  data() {
    return {
      dateRange: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      summaryHeader: '',
      summaryBody: '',
      summaryRaw: '',
      isLoading: false,
      searched: false,
      copied: false
    }
  },
  methods: {
    async loadData() {
      if (!this.dateRange[0] || !this.dateRange[1]) return
      this.isLoading = true
      this.searched = false
      this.summaryHeader = ''
      this.summaryBody = ''

      const data = await serviceRoutes.getDataSummary(this.dateRange[0], this.dateRange[1]).catch(() => null)

      if (data && data.data && data.data.length > 0) {
        this.summaryHeader = data.data[0]
        const bodyText = data.data.slice(1).join('\n')
        this.summaryRaw = this.summaryHeader + '\n' + bodyText
        this.summaryBody = bodyText.replace(/\n/g, '<br>')
      }

      this.isLoading = false
      this.searched = true
    },
    async copySummary() {
      await navigator.clipboard.writeText(this.summaryRaw)
      this.copied = true
      setTimeout(() => { this.copied = false }, 2000)
    }
  }
}
</script>

<style scoped>
.summary-card {
  border-radius: 12px;
  border: 1px solid #ddd;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.summary-header {
  background-color: #3d5a80;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 14px 20px;
}

.btn-copy {
  background-color: rgba(255, 255, 255, 0.15);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  font-size: 0.8rem;
}

.btn-copy:hover {
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.summary-body {
  padding: 20px;
  font-size: 0.95rem;
  line-height: 1.8;
  white-space: pre-wrap;
}
</style>
